import { Link } from "react-router-dom";
import { actors } from "@/mocks/actors";
import type { Movie } from "@/types/media";

export default function CastList({ movie }: { movie: Movie }) {
  return (
    <section className="mt-10">
      <h2 className="font-heading font-bold text-xl text-foreground-950 flex items-center gap-2 mb-4">
        <span className="w-1 h-5 rounded-full bg-accent-500"></span>
        演员列表
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {movie.actors.map((a) => {
          const detail = actors.find((x) => x.id === a.id);
          return (
            <Link
              key={a.id}
              to={`/actor/${a.id}`}
              className="group flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 rounded-full overflow-hidden bg-background-200">
                {detail && (
                  <img
                    src={detail.avatar}
                    alt={`${a.name} 头像`}
                    title={`${a.name} 演员资料`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                )}
              </span>
              <span className="min-w-0">
                <span className="block font-medium text-sm text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {a.name}
                </span>
                <span className="block text-xs text-foreground-500 truncate">
                  {detail ? detail.tags[0] : "演员"}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}